import { render, staticRenderFns } from "./certificates.vue?vue&type=template&id=174324cb&scoped=true&"
import script from "./certificates.vue?vue&type=script&lang=js&"
export * from "./certificates.vue?vue&type=script&lang=js&"
import style0 from "./certificates.vue?vue&type=style&index=0&id=174324cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174324cb",
  null
  
)

export default component.exports